<template>
    <div>
      <dashboard-page-title :showFilter="false" :showSearch="false" :showExportation="false" :showAddBtn="false">اضافة قسم شاحنة جديد</dashboard-page-title>
      <ValidationObserver v-slot="{ handleSubmit, invalid }">
        <b-form class="position-relative form-top w-50 " @submit.prevent="handleSubmit(addType)">
          <b-tabs content-class="mt-3">
            <b-tab v-for="(lang, key) in translations" :key="key" :title="lang.langLabel || lang.lang" >
              <input-form :label="' الاسم - ' + (lang.langLabel || lang.lang)" placeholder="الاسم" v-model="lang.name" :disabled="routeName === 'viewVehicleType'" :validate="lang.is_default ? 'required':'' " />
            </b-tab>
          </b-tabs>
          <cropper-images
              label="رفع الصورة الرئيسية"
              nameOfImage="image.jpg"
              @cropper-save="saveMasterImage"
              :progressLoading="loadingLogo"
              :showProgress="false"
              :multi="false"
              :imageUrl="vehicleType.logo"
          />
          <input-form label="عدد الموتون" placeholder="عدد الموتون" v-model="vehicleType.capacity" :disabled="routeName === 'viewVehicleType'" :validate="'required|numeric'" />
          <input-form label="سعر الكيلومتر" placeholder="سعر الكيلومتر" v-model="vehicleType.kilometerPrice" :disabled="routeName === 'viewVehicleType'" :validate="'required|numeric'" />
          <b-button v-if="routeName !== 'viewVehicleType'" variant="primary" :disabled="invalid" type="submit"><span  class="font-size-18 px-5">اضافة</span></b-button>
        </b-form>
      </ValidationObserver>
    </div>
</template>

<script>
import { core } from '@/config/pluginInit'
import transportationServices from '@/modules/transportation/services/transportation'
import getLanguages from '@/mixins/getLanguages'
import globalFunctionLang from '@/mixins/globalAdd'
// const formData = new FormData()
export default {
  name: 'addVehicleType',
  mixins: [getLanguages, globalFunctionLang],
  data () {
    return {
      loadingLogo: 0,
      vehicleType: {
        image: '',
        capacity: '',
        kilometerPrice: ''
      },
      routeName: this.$route.name,
      translatedColumns: ['name'],
      translations: []
    }
  },
  methods: {
    buildTranslations (isEdit = false) {
      const source = isEdit
        ? this.translations
        : this.translations.filter(translation => this.translatedColumns.some(column => translation[column]))

      return source.map(translation => {
        const item = { lang: translation.lang }
        if (translation.id) {
          item.id = translation.id
        }
        this.translatedColumns.forEach(column => {
          item[column] = translation[column]
        })
        return item
      })
    },
    getTypeData () {
      this.translations = []
      transportationServices.getVehicleType(this.$route.params.id).then(res => {
        const data = res.data.data
        this.vehicleType.image = data.image
        this.vehicleType.logo = data.image
        this.vehicleType.capacity = data.capacity
        this.vehicleType.kilometerPrice = data.kilometerPrice
        const apiTranslations = Array.isArray(data.translations)
          ? data.translations
          : []
        this.translations = this.handleResponseTranselation(this.translatedColumns, apiTranslations)
          .map(translation => {
            const langMeta = this.getAllLanguages.find(l => l.lang === translation.lang) || {}
            return { ...translation, langLabel: langMeta.name, is_default: langMeta.is_default }
          })
      })
    },
    addType () {
      if (this.$route.name === 'editVehicleType') {
        this.editType()
      } else {
        transportationServices.addVehicleType({
          image: this.vehicleType.image,
          capacity: this.vehicleType.capacity,
          kilometerPrice: this.vehicleType.kilometerPrice,
          translations: this.buildTranslations()
        }).then(res => {
          core.showSnackbar('success', res.data.message)
          this.$router.push({ name: 'vehiclesTypes' })
        })
      }
    },
    saveMasterImage (file) {
      const formData = new FormData()
      formData.append('directory', 'VehicleTypes')
      formData.append('image_name', file.imageInfo.name)
      formData.append('image', file.image)
      const options = {
        onUploadProgress: (progressEvent) => {
          const { loaded, total } = progressEvent
          const percent = Math.floor((loaded * 100) / total)
          this.loadingLogo = percent
        }
      }
      this.commonUploadFiles(formData, options).then(res => {
        this.vehicleType.image = res.data
        this.showSuccessUploadFile()
      })
    },
    editType () {
      transportationServices.editVehicleType(this.$route.params.id, {
        image: this.vehicleType.image,
        capacity: this.vehicleType.capacity,
        kilometerPrice: this.vehicleType.kilometerPrice,
        translations: this.buildTranslations(true)
      }).then(() => {
        core.showSnackbar('success', 'تم تعديل بنجاح')
        this.$router.push({ name: 'vehiclesTypes' })
      })
    }
  },
  mounted () {
    core.index()
  },
  created () {
    if (this.$route.params.id) {
      this.getTypeData()
    } else {
      this.getAllLanguages.forEach(langData => {
        const translation = {
          lang: langData.lang,
          langLabel: langData.name,
          is_default: langData.is_default
        }
        this.translatedColumns.forEach(column => {
          translation[column] = ''
        })
        this.translations.push(translation)
      })
    }
  }
}
</script>
